import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleReceiptDetailsDialog } from "../redux/GlobalStates";

const useReceipt = () => {
  const dispatch = useDispatch();
  const allReceipt = useSelector((state) => state.receipts.Receipts);
  const [search_by, setSearchBy] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const toggleShowReceipt = () => dispatch(toggleReceiptDetailsDialog());

  const [receipt, setReceipt] = useState();
  const receipts = searchTerm
    ? allReceipt.filter((receipt) =>
        search_by === "date"
          ? receipt.date.endsWith(searchTerm)
          : search_by === "purchaser"
            ? receipt.purchaser.toLowerCase().includes(searchTerm.toLowerCase())
            : search_by === "issuer"
              ? receipt.issuer
                  ?.toLowerCase()
                  .includes(searchTerm?.toLowerCase())
              : receipt.id.includes(searchTerm),
      )
    : allReceipt;

  return {
    search_by,
    setSearchBy,
    searchTerm,
    setSearchTerm,
    receipts,
    toggleShowReceipt,
    // showReceipt,
    receipt,
    setReceipt,
    // setShowReceipt,
    allReceipt,
  };
};

export default useReceipt;
